// extracted by mini-css-extract-plugin
export default {"button":"DrawerCloseButton_button__w+WMJ","srLabel":"DrawerCloseButton_srLabel__il60m"};